// @flow

import { updateConfig } from '../base/config';
import { SET_AUDIO_MUTED, SET_VIDEO_MUTED } from '../base/media';
import { MiddlewareRegistry } from '../base/redux';
import { updateSettings } from '../base/settings';
import {
    TRACK_ADDED,
    TRACK_NO_DATA_FROM_SOURCE,
    getLocalTracks,
    replaceLocalTrack
} from '../base/tracks';
import { getBackendSafeRoomName } from '../base/util';

import { PREJOIN_START_CONFERENCE } from './actionTypes';
import {
    setDeviceStatusOk,
    setDeviceStatusWarning,
    setPrejoinPageVisibility
} from './actions';
import { isPrejoinPageVisible } from './functions';

declare var APP: Object;


/**
 * The redux middleware for {@link PrejoinPage}.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => async action => {
    switch (action.type) {
    case PREJOIN_START_CONFERENCE: {
        const { getState, dispatch } = store;
        const state = getState();
        const { userSelectedSkipPrejoin } = state['features/prejoin'];
        const roomName = getBackendSafeRoomName(state['features/base/conference'].room);
        const localTracks = getLocalTracks(state['features/base/tracks']);
        const { options } = action;

        APP.conference.prejoinConnect(roomName);

        setTimeout(async () => {
            options && store.dispatch(updateConfig(options));

            userSelectedSkipPrejoin && dispatch(updateSettings({
                userSelectedSkipPrejoin
            }));

            // Do not signal audio/video tracks if the user joins muted.
            for (const track of localTracks) {
                if (track.muted) {
                    await dispatch(replaceLocalTrack(track.mhTrack, null));
                }
            }
            const mhTracks = localTracks.map(t => t.mhTrack);

            dispatch(setPrejoinPageVisibility(false));
            APP.conference.prejoinStart(mhTracks);
        }, 500);

        // try {
        //     const format1 = 'YYYY-MM-DD HH:mm:ss';
        //     const currentDateTime = moment().format(format1);
        //     const bowser = new BrowserDetection();
        //     const browserName = bowser.getName();
        //     let accessType = 'web';
        //     const participant = getLocalParticipant(APP.store.getState());

        //     for (const i in bowserNameToJitsiName) {
        //         if (i !== browserName) {
        //             accessType = 'app';
        //         }
        //     }
        //     const roomName = getBackendSafeRoomName(getState()['features/base/conference'].room);
        //     let dataJson;


        //     try {
        //         const getData = await fetchApi('https://geolocation-db.com/json/0f761a30-fe14-11e9-b59f-e53803842572')
        //         .catch(e => console.log('Error in fetching geolocation bros', e?.status));


        //         if (getData) {
        //             dataJson = await getData.json();
        //         }
        //     } catch (errors) {
        //         try {
        //             const getData = await fetchApi('geolocation', 'get', {
        //                 'Content-Type': 'application/json'
        //             }).catch(e => console.log('Error in fetching geolocation bros', e?.status));

        //             // eslint-disable-next-line max-depth
        //             if (getData) {
        //                 dataJson = await getData.json();
        //             }
        //         // eslint-disable-next-line no-catch-shadow
        //         } catch (error) {
        //             console.log('Error in fetching geolocation bros', error);

        //         }


        //     }

        //     const { occurenceId } = state['features/base/mtApi'];

        //     const userObject = {
        //         // eslint-disable-next-line camelcase
        //         meeting_id: roomName,
        //         name: participant?.name,
        //         // eslint-disable-next-line camelcase
        //         occurrence_id: occurenceId,
        //         // eslint-disable-next-line camelcase
        //         is_host: state['features/base/jwt'].jwt ? 1 : 0,
        //         // eslint-disable-next-line camelcase
        //         email_id: participant?.email,
        //         // eslint-disable-next-line camelcase
        //         login_datetime: currentDateTime,
        //         // eslint-disable-next-line camelcase
        //         user_agent: browserName,
        //         // eslint-disable-next-line camelcase
        //         access_type: accessType,
        //         ip: dataJson?.IPv4
        //     };


        //     const userJson = JSON.stringify(userObject);
        //     const sendUserData = await fetchApi('meeting/save_meeting_attendance',
        //         'post',
        //          {
        //              'Content-Type': 'application/json'
        //          },
        //         userJson
        //     );

        //     await sendUserData.json();
        // } catch (e) {
        //     console.log('%c Error in fetching geolocation', 'background: #222; color: #bada55');
        // }


        break;
    }

    case SET_AUDIO_MUTED: {
        if (isPrejoinPageVisible(store.getState())) {
            store.dispatch(updateSettings({
                startWithAudioMuted: Boolean(action.muted)
            }));
        }
        break;
    }

    case SET_VIDEO_MUTED: {
        if (isPrejoinPageVisible(store.getState())) {
            store.dispatch(updateSettings({
                startWithVideoMuted: Boolean(action.muted)
            }));
        }
        break;
    }

    case TRACK_ADDED:
    case TRACK_NO_DATA_FROM_SOURCE: {
        const state = store.getState();

        if (isPrejoinPageVisible(state)) {
            const { track: { mhTrack: track } } = action;
            const { deviceStatusType, deviceStatusText } = state['features/prejoin'];

            if (!track.isAudioTrack()) {
                break;
            }

            if (track.isReceivingData()) {
                if (deviceStatusType === 'warning'
                    && deviceStatusText === 'prejoin.audioDeviceProblem') {
                    store.dispatch(setDeviceStatusOk('prejoin.lookGood'));
                }
            } else if (deviceStatusType === 'ok') {
                store.dispatch(setDeviceStatusWarning('prejoin.audioDeviceProblem'));
            }
        }
        break;
    }

    }

    return next(action);
});
